import styled from 'styled-components'

export const StyledFullDetailsSection = styled.div`
margin-top: 3rem;
background-color: #fff;
padding: 0 3rem;
`;

export const StyledFullDetailsSectionItem = styled.div`
    padding: 3rem 0;
    border-bottom: 1px solid rgba(33, 63, 125, 0.1);

    .item-title {
        font-weight: 500;
        font-size: 1.6rem;
        color: #213F7D;
    }

    .info-details {
        display: flex;
        flex-wrap: wrap;
        margin-top: 3rem;
        gap: 3rem;

        > div {
            width: 21.4rem;

            .item-sub-title {
                font-weight: 400;
                font-size: 1.2rem;
                text-transform: uppercase;
                color: #545F7D;
            }

            .item-sub-text {
                font-weight: 500;
                font-size: 1.6rem;
                color: #545F7D
            }
        }
    }
`;